import { catchError, map, Observable, of } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Constants } from "@constants";
import { DatosEmailGmailLlmDTO, IDatosEmailGmailLlmDTO } from "@DTOS";

@Injectable({
    providedIn: "root"
})
export class ResponseGeneratorGmailServiceBackend {
    constructor(protected httpClient: HttpClient) {}

    public getGmailEmails(): Observable<DatosEmailGmailLlmDTO[]> {
        return this.httpClient.get<IDatosEmailGmailLlmDTO[]>(`${Constants.apiURL}/response-generator/gmail/emails`).pipe(
            catchError(() => of<IDatosEmailGmailLlmDTO[]>([])),
            map(emails => emails.map(email => new DatosEmailGmailLlmDTO(email)))
        );
    }

    public postGmailEmails(datosEmail: DatosEmailGmailLlmDTO[]): Observable<void> {
        return this.httpClient.post<void>(`${Constants.apiURL}/response-generator/gmail/emails`, datosEmail.map(email => email.toJSON()));
    }
}
